export default __webpack_public_path__ + "static/media/heart-svgrepo-com.4f4d75f3.svg";